<template>
    <div class="comprehensie_analysis">
    <moe-empty url="development_icon_gray.png" emptyText="功能开发中，敬请期待"></moe-empty>
        <!-- <div class="flex progress_box mar_top_20 FlexBetween">
            <div class="progress_one">
                <div class="study_text">课程知识点优势：<span class="study_label">集合</span></div>
                <div class="study_text">课程知识点劣势：<span class="study_label">三角函数</span></div>
            </div>
            <div class="progress_one">
                <div class="study_text">课程知识点优势：<span class="study_label">集合</span></div>
                <div class="study_text">课程知识点劣势：<span class="study_label">三角函数</span></div>
            </div>
        </div>
        <div class="charts_box flex FlexBetween">
            <div class="charts_one">
                <scoreRadar :color="chartsColor1"></scoreRadar>
            </div>
            <div class="charts_one">
                <scoreRadar :color="chartsColor1"></scoreRadar>
            </div>
        </div>
        <div class="flex progress_box mar_top_20 FlexBetween">
            <div class="progress_one">
                <div class="study_text">课程能力优势：<span class="study_label">抽象概括力</span></div>
                <div class="study_text">课程能力劣势：<span class="study_label">应用知识和创新意识</span></div>
            </div>
            <div class="progress_one">
                <div class="study_text">课程能力优势：<span class="study_label">数学抽象</span></div>
                <div class="study_text">课程能力劣势：<span class="study_label">数学分析</span></div>
            </div>
        </div>
        <div class="charts_box flex FlexBetween">
            <div class="charts_one">
                <scoreRadar :color="chartsColor2"></scoreRadar>
            </div>
            <div class="charts_one">
                <scoreRadar :color="chartsColor2"></scoreRadar>
            </div>
        </div>
        <div class="question_type flex mar_top_10">
            <div class="study_text">擅长题型：<span class="study_label">选择题</span></div>
            <div class="study_text mar_left_30">劣势题型：<span class="study_label">解答题</span></div>
        </div>
        <div class="charts_box flex FlexBetween">
            <div class="charts_one">
                <pie></pie>
            </div>
            <div class="charts_one">
                <pie></pie>
            </div>
        </div>
        <div class="score_situation mar_top_20">课程平时各阶段测试得分情况</div>
        <div class="flex adept_chapter mar_top_15">
            <div class="score_situation_label">擅长章节：<span class="text_active">有理数 无理数 代数式</span></div>
            <div class="score_situation_label">劣势项章节：<span class="text_active">有理数 无理数 代数式</span></div>
        </div>
        <div class="charts_bar_box">
            <barCharts></barCharts>
        </div>
        <div class="score_situation mar_top_20">学习建议</div>
        <div class="question_type study_suggestion mar_top_20">
            <div>1.重点攻克弱项：圆，统计/概率等知识点</div>
            <div>2.学习时长建议每天保持在30分钟以上，目前的时间不太稳定</div>
            <div>3.建议重点复习第三章节</div>
        </div> -->
    </div>
</template>

<script>
// import scoreRadar from '@/components/echarts/scoreRadar.vue';
// import pie from '@/components/echarts/pie.vue';
// import barCharts from '@/components/echarts/barCharts.vue';
export default {
    name: 'GjkcH5ComprehensiveAnalysis',

    components: {
        // scoreRadar, pie, barCharts
    },
    data() {
        return {
            chartsColor1: 'rgba(218, 249, 243, 1)',
            chartsColor2: 'rgba(192, 190, 255, 1)'
        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.comprehensie_analysis {
    padding-bottom: 30px;

    .progress_box {
        .progress_one {
            width: 351px;
            height: 90px;
            background: rgba(238, 250, 248, 0.6);
            border-radius: 10px;
            padding: 15px 20px;
            box-sizing: border-box;

            .study_text {
                color: #666666;
                font-weight: bold;
                line-height: 30px;
            }

            .study_label {
                color: #333333;
                font-weight: bold;
            }
        }
    }

    .charts_box {
        .charts_one {
            width: 360px;
            height: 300px;
        }
    }

    .question_type {
        width: 100%;
        min-height: 56px;
        background: rgba(19, 214, 170, 0.05);
        border-radius: 10px;
        line-height: 56px;
        padding: 0 20px;
        box-sizing: border-box;

        .study_text {
            color: #666666;
            font-weight: bold;
        }

        .study_label {
            color: #333333;
            font-weight: bold;
        }
    }

    .score_situation {
        font-weight: bold;
        font-size: 18px;
        color: #333333;
    }

    .adept_chapter {
        color: #666666;
    }

    .charts_bar_box {
        width: 100%;
        height: 350px;
    }

    .study_suggestion {
        color: #666666;
        line-height: 28px;
        padding: 20px;
    }
}
</style>